import React, { useState } from "react";
import { Button } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import parser from "../../../../shared/helpers/parser";
import Utils from "../../../../shared/helpers/utils";

const str = val => String(val ?? '');

const ExportInformeEstablecimientoPDF = ({
  filteredTrabajadores,
  establecimientosEmpresa,
  anexoi,
  anexov,
  cuit,
}) => {
  const [loading, setLoading] = useState(false);

  const getEstablecimiento = (id) => {
    if (!anexoi?.EstablecimientosDeclarados) return null;
    return anexoi.EstablecimientosDeclarados.find(x => x.IdEstablecimientoEmpresa == id);
  };

  const downloadPDF = () => {
    setLoading(true);
    setTimeout(() => {
      const today = new Date();
      const formattedDate = today.toLocaleString(undefined, { hour12: false });
      const sustancias = anexov?.Sustancias || [];

      // --- Agrupar trabajadores filtrados por establecimiento ---
      const porEstablecimiento = {};
      (filteredTrabajadores || []).forEach(t => {
        const idEst = t.IdEstablecimientoEmpresa;
        if (!porEstablecimiento[idEst]) porEstablecimiento[idEst] = [];
        porEstablecimiento[idEst].push(t);
      });

      const content = [
        {
          text: 'Informe por Establecimiento',
          bold: true,
          fontSize: 18,
          alignment: 'center',
          margin: [0, 0, 0, 5],
        },
        {
          columns: [
            { text: `CUIT: ${cuit || ''}`, fontSize: 10, alignment: 'left' },
            { text: `Fecha de generacion: ${formattedDate}`, fontSize: 10, alignment: 'right' },
          ],
          margin: [0, 0, 0, 4],
        },
        {
          text: `Total de trabajadores (filtrados): ${(filteredTrabajadores || []).length}`,
          fontSize: 9,
          alignment: 'left',
          margin: [0, 0, 0, 10],
          color: '#555555',
        },
        {
          canvas: [{ type: 'line', x1: 0, y1: 0, x2: 760, y2: 0, lineWidth: 0.5 }],
          margin: [0, 0, 0, 14],
        },
      ];

      // --- Una sección por cada establecimiento ---
      Object.keys(porEstablecimiento).forEach((idEst, idx) => {
        const trabajadoresDelEst = porEstablecimiento[idEst];
        const estDesc = str(Utils.getIdDesc(idEst, establecimientosEmpresa));
        const establecimiento = getEstablecimiento(idEst);
        const puestos = establecimiento?.Puestos || [];
        const sectores = establecimiento?.Sectores || [];

        // Título del establecimiento
        content.push({
          text: `Establecimiento: ${estDesc}`,
          bold: true,
          fontSize: 13,
          margin: idx === 0 ? [0, 0, 0, 3] : [0, 16, 0, 3],
          color: '#1890ff',
        });

        content.push({
          text: `Total de trabajadores: ${trabajadoresDelEst.length}`,
          fontSize: 9,
          margin: [0, 0, 0, 6],
          color: '#555555',
        });

        // Construir filas: una fila por actividad de cada trabajador
        // Si no tiene actividades, igual aparece con una fila vacía
        const tableBody = [
          [
            { text: 'Id Trabajador', bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'CUIL',          bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'Fecha Ingreso', bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'Puesto',        bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'Sector',        bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'Permanente',    bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'Sustancia Declarada', bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'F. Inicio Exposicion', bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
            { text: 'F. Fin Exposicion',    bold: true, fillColor: '#1890ff', color: '#fff', fontSize: 7 },
          ]
        ];

        trabajadoresDelEst.forEach(t => {
          const actividades = t.Actividades || [];
          const idTrabajador = str(t.IdTrabajador);
          const cuil         = str(t.Cuil);
          const fechaIngreso = parser.date(t.FechaIngreso);

          if (actividades.length === 0) {
            // Trabajador sin actividades: fila única con datos básicos
            tableBody.push([
              { text: idTrabajador, fontSize: 7 },
              { text: cuil,         fontSize: 7 },
              { text: fechaIngreso, fontSize: 7 },
              { text: '',           fontSize: 7 },
              { text: '',           fontSize: 7 },
              { text: '',           fontSize: 7 },
              { text: '',           fontSize: 7 },
              { text: '',           fontSize: 7 },
              { text: '',           fontSize: 7 },
            ]);
          } else {
            // Una fila por cada actividad; en la primera fila van los datos del trabajador
            actividades.forEach((a, aIdx) => {
              const puestoDesc    = str(Utils.getIdDesc(a.IdPuestoDeclarado, puestos));
              const sectorDesc    = str(Utils.getIdDesc(a.IdSectorDeclarado, sectores));
              const sustanciaDesc = str(Utils.getIdDesc(a.IdSustanciaDeclarada, sustancias));
              const permanente    = a.Permanente === true ? 'Si' : 'No';
              const fIni          = parser.date(a.FechaInicioExposicion);
              const fFin          = parser.date(a.FechaFinExposicion);

              if (aIdx === 0) {
                // Primera actividad: incluye datos del trabajador y fondo alternado
                tableBody.push([
                  { text: idTrabajador, fontSize: 7, bold: true },
                  { text: cuil,         fontSize: 7, bold: true },
                  { text: fechaIngreso, fontSize: 7, bold: true },
                  { text: puestoDesc,    fontSize: 7 },
                  { text: sectorDesc,    fontSize: 7 },
                  { text: permanente,    fontSize: 7 },
                  { text: sustanciaDesc, fontSize: 7 },
                  { text: fIni,          fontSize: 7 },
                  { text: fFin,          fontSize: 7 },
                ]);
              } else {
                // Actividades adicionales del mismo trabajador: celdas de trabajador vacías con fondo gris claro
                tableBody.push([
                  { text: '',            fontSize: 7, fillColor: '#f5f5f5' },
                  { text: '',            fontSize: 7, fillColor: '#f5f5f5' },
                  { text: '',            fontSize: 7, fillColor: '#f5f5f5' },
                  { text: puestoDesc,    fontSize: 7, fillColor: '#f5f5f5' },
                  { text: sectorDesc,    fontSize: 7, fillColor: '#f5f5f5' },
                  { text: permanente,    fontSize: 7, fillColor: '#f5f5f5' },
                  { text: sustanciaDesc, fontSize: 7, fillColor: '#f5f5f5' },
                  { text: fIni,          fontSize: 7, fillColor: '#f5f5f5' },
                  { text: fFin,          fontSize: 7, fillColor: '#f5f5f5' },
                ]);
              }
            });
          }
        });

        content.push({
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', '*', '*', 'auto', '*', 'auto', 'auto'],
            body: tableBody,
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#cccccc',
            vLineColor: () => '#cccccc',
          },
        });
      });

      const documentDefinition = {
        pageOrientation: 'landscape',
        pageMargins: [30, 50, 30, 30],
        content,
        footer: (currentPage, pageCount) => ({
          columns: [
            { text: `Pagina ${currentPage} de ${pageCount}`, alignment: 'left', fontSize: 8, margin: [30, 0, 0, 0] },
            { text: `Impreso: ${formattedDate}`, alignment: 'right', fontSize: 8, margin: [0, 0, 30, 0] },
          ],
        }),
      };

      pdfMake.createPdf(documentDefinition).download(`informe_establecimientos_${cuit || 'export'}.pdf`, () => {
        setLoading(false);
      });
    }, 0);
  };

  return (
    <Button
      onClick={downloadPDF}
      type="default"
      icon={<FileTextOutlined />}
      loading={loading}
    >
      Informe por Establecimiento
    </Button>
  );
};

export default ExportInformeEstablecimientoPDF;
